import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-very-satured-chip',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './very-satured-chip.component.html',
  styleUrls: ['./very-satured-chip.component.scss'],
})
export class VerySaturedChipComponent {

}
